import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {NotifierService} from 'angular-notifier';
import {TestArea} from 'src/app/common/test-area';
import {ApiService} from 'src/app/services/api.service';
import {ErrorHelper} from '../../common/ErrorHelper';

export interface AssetProfile {
  disId: string;
  pathName: string;
  content: string;
}

@Component({
  selector: 'app-manage-asset-profile',
  templateUrl: './manage-asset-profile.component.html',
  styleUrls: ['./manage-asset-profile.component.css']
})
export class ManageAssetProfileComponent implements OnInit {

  displayedColumns: string[] = ['disId', 'pathName', 'content', 'reprocess'];
  dataSource: MatTableDataSource<AssetProfile>;

  constructor(private apiService: ApiService,
              private notifierService: NotifierService,
              public dialog: MatDialog) {
    this.loadAssetProfilesListAsync();
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
  }

  selectTestArea(test: TestArea): void {
    this.loadAssetProfilesListAsync();
  }

  async loadAssetProfilesListAsync(): Promise<any> {
    try {
      await this.loadAssetProfilesList();
    } catch (error) {
      console.log(error);
    }
  }

  loadAssetProfilesList(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getAssetProfilesList().toPromise().then(
        (data) => {
          const configs = data;
          this.dataSource = new MatTableDataSource(configs);
          console.log('Fetched the asset profiles list');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load asset profiles', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  showFileContent(content: string): void {
    this.dialog.open(DialogAssetFileContentComponent, {
      data: {
        text: content
      },
      width: '1000px',
      maxWidth: '100vw',
    });
  }

  reprocess(disId: string): void {
    this.apiService.reprocessAssetProfile(disId).subscribe(
      (success) => {
        this.notifierService.notify('info', 'Reprocess of asset profile ' + disId + ' started.');
      },
      (error) => {
        const errorMessage = ErrorHelper.disectError('Reprocess of asset profile ' + disId + ' failed!', error);
        this.notifierService.notify('error', errorMessage);
      });
  }

}

@Component({
  selector: 'app-dialog-asset-file-content',
  templateUrl: 'dialog-asset-file-content.component.html',
})
export class DialogAssetFileContentComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
}

export interface DialogData {
  text: string;
}
